import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

/**
 * Configuração do Firebase
 *
 * IMPORTANTE: Substitua as credenciais abaixo pelas suas próprias!
 *
 * Para obter suas credenciais:
 * 1. Acesse: https://console.firebase.google.com
 * 2. Crie um novo projeto (ou use um existente)
 * 3. Vá em "Configurações do Projeto" > "Seus aplicativos"
 * 4. Clique em "Adicionar app" > Escolha "Web"
 * 5. Copie as credenciais do firebaseConfig
 */

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "SUA_API_KEY_AQUI",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "seu-projeto.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "seu-projeto-id",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "seu-projeto.appspot.com",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "123456789",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:123456789:web:abcdef123456"
};

// Inicializa o Firebase
const app = initializeApp(firebaseConfig);

// Inicializa o Firestore
const db = getFirestore(app);

export { db };
export default app;
